$(document).ready(function(){

    var stick;
    var currentAnchorIndex = 0;
    var luft = 0;

    var getStickEl = function(gridWidth){
        if(gridWidth < 768){
            var el = $('.seminar_h1 .seminars_list--day_header--floating');
        }else{
            var el = $('.seminar_h1');
        }
        return el;
    }

    var anchors = [];
    $('a[data-day-anchor]').each(function(i, anchor){
        anchors.push({
            'name':  $(anchor).attr('name')
        });
    })

    var updateAnchorPositions = function(){
        $('a[data-day-anchor]').each(function(i, anchor){
            var AnchorOffset = $(anchor).offset().top
            anchors[i].pos = AnchorOffset - luft - 20;
        });

        currentAnchorIndex = 0;
        checkPositions();
    }

    var checkPositions = function (){
        var scroll = $(document).scrollTop();

        if(anchors[currentAnchorIndex+1]){
            var nextPos =  anchors[currentAnchorIndex + 1].pos;
            if (scroll >= nextPos){
                currentAnchorIndex = currentAnchorIndex + 1;
                updateNavbar();
            }
        }
        if( currentAnchorIndex > 0){
            var prevPos = anchors[currentAnchorIndex - 1].pos;
            if(scroll < prevPos){
                currentAnchorIndex = currentAnchorIndex - 1;
                updateNavbar();
            }
        }
    }



    var visibleCount;
    visibleCount = parseInt($('.seminars_list--day_header--next_days').data('visible-count'));
    var mobileVisibleCount;
    mobileVisibleCount = parseInt($('.seminars_list--day_header--next_days').data('visible-count-mobile'));

    var updateNavbar = function () {

        $('.seminars_list--day_header--next_days .more-button.more-button__active').removeClass('more-button__active');

        setTimeout(function(){

            $('.seminars_list--day_header--next_days .more-button').eq(currentAnchorIndex).addClass('more-button__active');
            var firstVisibleIndex = currentAnchorIndex - Math.floor(visibleCount/2);
            firstVisibleIndex = firstVisibleIndex < 0 ? 0 : firstVisibleIndex;
            $('.seminars_list--day_header--next_days .more-button').each(function(buttonIndex, button){
                if($(button).hasClass('next_days--button__visible')){
                    if( (buttonIndex < firstVisibleIndex) || (buttonIndex >= firstVisibleIndex + visibleCount)){
                        $(button).removeClass('next_days--button__visible')
                    }
                }else{
                    if( (buttonIndex >= firstVisibleIndex) && (buttonIndex < firstVisibleIndex + visibleCount)){
                        $(button).addClass('next_days--button__visible')
                    }
                }
            })

            var firstVisibleIndex = currentAnchorIndex - Math.floor(mobileVisibleCount/2);
            firstVisibleIndex = firstVisibleIndex < 0 ? 0 : firstVisibleIndex;
            $('.seminars_list--day_header--next_days .more-button').each(function(buttonIndex, button){
                if($(button).hasClass('next_days--button__visible-mobile')){
                    if( (buttonIndex < firstVisibleIndex) || (buttonIndex >= firstVisibleIndex + mobileVisibleCount)){
                        $(button).removeClass('next_days--button__visible-mobile')
                    }
                }else{
                    if( (buttonIndex >= firstVisibleIndex) && (buttonIndex < firstVisibleIndex + mobileVisibleCount)){
                        $(button).addClass('next_days--button__visible-mobile')
                    }
                }
            })

        },300)
    }

    $(window).on('media.pageStateInit', function(e, state){
        stick = getStickEl(state.bootstrapGrid);
        var bot = $('#footer').height()+parseInt($('#footer').css('marginTop'));
        stick.sticky({topSpacing:state.floatingTopHeight, bottomSpacing: bot});
        luft = stick.height() + state.floatingTopHeight;
        updateAnchorPositions();
    })

    $(window).on('media.pageStateChange', function(e, state){
        if(state.previousFloatingTopHeight != state.floatingTopHeight){
            var el = getStickEl(state.bootstrapGrid);
            if(!el.is(stick)){
                stick.unstick();
                stick = el;
            }
            var bot = $('#footer').height()+parseInt($('#footer').css('marginTop'));
            stick.sticky({topSpacing:state.floatingTopHeight, bottomSpacing: bot});
        }
        luft = stick.height() + state.floatingTopHeight;
        updateAnchorPositions()
    })

    $(window).scroll(function(){
        checkPositions();
    });

    $('.seminars_list--item_highlited .seminar_info--col_left').autoHeight({
        'target': '.anons a'
    });
    //$('.seminars_list--day_header--next_days a')
    //more-button more-button__active
});
